module.exports = __webpack_public_path__ + "img/[破涕为笑].f7d73b79.svg";